import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SvgAssets } from '../../../assets/icons/iconSvg';
import c from '../../../constants/Colors';
import CounterInput from '../../../components/reusable/CounterInput';
import { numberWithCommas } from '../../../utilitarios/util';
import { data } from '../../../constants/Constants';
const ModalReemplazo = ({modal, dadComponent, reemplazo, auth}) => {
  // const VISIBLE = dadComponent.state.dataReemplazo.isVisible;
  const VISIBLE = modal.isVisible;
  const HIDE_MODAL = dadComponent['CerrarReemplazo'];

  return (
    <div>
      {/* <Button color="danger">modal</Button> */}
      <Modal isOpen={VISIBLE} className='modal_reemplazar' centered>
        {/* <ModalHeader toggle={toggle}>Modal title</ModalHeader> */}
        <ModalBody>
          <button className="btn-icon modal-close" onClick={HIDE_MODAL}><SvgAssets icon="icon-close" fill={c.azulClaro} /></button>
          <h6 className="title-3 bold"><SvgAssets icon="icon-foco"/>Puedes reemplazar el repuesto por:</h6>
          <div className="cards_scroll">
          {dadComponent.state.dataReemplazo.data.map((item, index) => {
            return(
              <div key={index} className="card_reemplazo">
                <div style={{ flex: 1, paddingRight:10 }}>
                  <div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input type="radio" id={`radio${item.idInput}`} name={`radio${item.idInput}`} className="custom-control-input" checked={reemplazo.idInput == item.idInput} onChange={() => dadComponent.seleccionarReemplazo(item)} />
                      <label className="custom-control-label" htmlFor={`radio${item.idInput}`} style={{ color: '#FF9446' }} />
                    </div>
                    <div>
                      <h6 className="paragraph-2 bold mb-1" style={{color:c.verdeClaro}}>{item.maktx}</h6>
                      <span className="paragraph-3 light d-block" style={{color:c.grisMedio}}>SKU: {item.matnr}</span>
                    </div>
                    <span className="paragraph-3 light mt-3 d-block">Total: <strong>{item.sWaers} {numberWithCommas(item.precioTotal)}</strong></span>
                  </div>
                </div>
                <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                  <div className="text-right">
                    <span className="paragraph-3 bold d-block">{item.precioPVD}</span>
                  </div>
                  <div className="options">
                    <button className='btn-icon'
                    onClick={() => dadComponent.postAgregarProductoReemplazoFavorito({
                      codigo: item.matnr, descripcion: item.maktx,
                      moneda: item.waers, pantalla: data.Pantalla.BuscarPedidoCodigo.Reemplazo
                    }, item.favorito, item.indice)}
                    >
                      <SvgAssets icon="icon-star" fill={item.favorito ? c.amarillo : c.celeste} />
                    </button>
                    <CounterInput
                      IdInput={item.idInput}
                      background={"#fff"}
                      color={c.azulClaro}
                      borderColor={c.grisClaro}
                      data={item}
                      eventCounter={dadComponent.setCounterReemplazo}
                    />
                  </div>
                </div>
              </div>
            )
          })
          }
          </div>
          <div className="text-center mt-5">
            <button className='btn-block bg_verde' type="button"
            disabled={reemplazo.cantidad == 0}
            onClick={() => dadComponent.ejectarReemplazo(auth.carritoProdctos, auth.setcarritoProdctos)}>
              Reemplazar<SvgAssets icon="icon-refresh" fill='#fff' className='ml-2' />
            </button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default ModalReemplazo;